import enCommon from "locales/en/common.json"
import enHome from "locales/en/home.json"

import ptCommon from "locales/pt/common.json"
import ptHome from "locales/pt/home.json"

const resources = {
	en: {
		common: enCommon,
		home: enHome,
	},
	pt: {
		common: ptCommon,
		home: ptHome,
	},
}

export default resources
